import {type Omit} from '@wandb/weave/common/types/base';

import type * as UtilReport from '../../../util/report';
import {type Ref as DiscussionThreadRef} from '../discussionThread/types';
import type * as MarkdownBlockTypes from '../markdownBlock/types';
import type * as PanelSettingsTypes from '../panelSettings/types';
import type * as SectionTypes from '../section/types';
import type * as ViewTypes from '../types';

export const REPORT_VIEW_TYPE = 'runs';
export const REPORT_DRAFT_VIEW_TYPE = 'runs/draft';
export const COLLECTION_OVERVIEW_VIEW_TYPE = 'collection-overview';
export const COLLECTION_OVERVIEW_DRAFT_VIEW_TYPE = 'collection-overview/draft';

export const REPORT_LIKE_VIEW_TYPES = [
  REPORT_VIEW_TYPE,
  REPORT_DRAFT_VIEW_TYPE,
  COLLECTION_OVERVIEW_VIEW_TYPE,
  COLLECTION_OVERVIEW_DRAFT_VIEW_TYPE,
] as const;

export type ReportLikeViewType = (typeof REPORT_LIKE_VIEW_TYPES)[number];

export function isReportLikeViewType(type: string): type is ReportLikeViewType {
  return REPORT_LIKE_VIEW_TYPES.includes(type as ReportLikeViewType);
}

export type ReportConfig = UtilReport.SlateReport;

export type ReportWidthOption = 'readable' | 'fixed' | 'fluid' | 'profile';

export type ReportPageNormalized = Omit<
  ReportConfig,
  'panelSettings' | 'discussionThreads'
> & {
  panelSettingsRef: ViewTypes.PartRefFromObjSchema<PanelSettingsTypes.PanelSettingsObjSchema>;
  discussionThreadRefs: DiscussionThreadRef[];
};

export type Ref = ViewTypes.PartRefFromObjSchema<ReportObjSchema>;

export type ViewRef = ViewTypes.ViewRefFromObjSchema<ReportObjSchema>;

export interface ReportObjSchema {
  type: 'runs'; // legacy name
  whole: ReportConfig;
  part: ReportPageNormalized;
}

export interface CollectionOverviewObjSchema {
  type: 'collection-overview';
  whole: ReportConfig;
  part: ReportPageNormalized;
}

export interface CollectionOverviewDraftObjSchema {
  type: 'collection-overview/draft';
  whole: ReportConfig;
  part: ReportPageNormalized;
}

export type ReportLikeObjSchema =
  | ReportObjSchema
  | CollectionOverviewObjSchema
  | CollectionOverviewDraftObjSchema;

export type ReportLikeViewRef =
  ViewTypes.ViewRefFromObjSchema<ReportLikeObjSchema>;

export type ReportLikeRef = ViewTypes.PartRefFromObjSchema<ReportLikeObjSchema>;

export type BlockRef = MarkdownBlockTypes.Ref | SectionTypes.Ref;
export type BlockConfig = MarkdownBlockTypes.Config | SectionTypes.Config;
